import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import AddCources from './AddCources';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input';

const Cources = () => {
  const [course, setCourse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [students, setStudents] = useState({});
  const [selectedCategory, setSelectedCategory] = useState('');

  const categoryFun = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/category', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCategory(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const studentDetails = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/total-students', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setStudents(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    categoryFun();
    studentDetails();
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCourse(data?.courses);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  }, []);

  const [open, setOpen] = useState(false);

  const filteredCourses = course?.filter((course) => {
    const matchesSearchQuery = course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory ? course.category === selectedCategory : true;
    return matchesSearchQuery && matchesCategory;
  });

  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by course name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddCources setIsModalOpen={setOpen} isModalOpen={open} />
      <div className=" flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Cources</h2>
          <p className=" text-[#1C1D1D]">Here overview of the courses</p>
        </div>
        <div className="cursor-pointer">
          <img onClick={() => setOpen(true)} src={require('../../assets/image/add.png')} alt="" />
        </div>
      </div>

      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-3 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              className="  bg-white p-5 rounded-lg flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Enrolled Students</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">{students?.totalEnrolled}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/active.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Ongoing Courses</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{students?.approved}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/ongoing.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  text-black flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{students?.completed}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="w-full pb-7">
        <label className="block mb-2 text-sm text-gray-900 font-medium">Filter By Category</label>
        <select
          name="category"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="w-full py-3 outline-none  bg-white shadow-lg p-2.5 text-black placeholder:text-primary rounded-md"
        >
          <option value="">Select Category</option>
          {category?.map((item, index) => (
            <option key={index} value={item?._id}>
              {item?.name}
            </option>
          ))}
        </select>
      </div>

      <section>
        {loading ? (
          <Loader /> // Show the loader while fetching courses
        ) : (
          <>
            {filteredCourses && filteredCourses.length > 0 ? (
              <>
                {filteredCourses.map((course) => (
                  <div className=" grid grid-cols-1 mt-4 gap-6" key={course._id}>
                    <Link
                      to={`/cources-details/${course?._id}`}
                      className=" bg-white flex md:flex-row flex-col  rounded-lg gap-4"
                      style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                    >
                      <div className="md:w-3/12 w-12/12">
                        <img
                          src={course?.image}
                          className="w-full h-64 object-cover rounded-lg"
                          alt=""
                        />
                      </div>

                      <div className=" md:w-8/12 w-12/12 p-4">
                        <h6 className=" pt-3 text-lg">{course?.name}</h6>
                        <div className=" flex gap-5 pt-2  items-center">
                          <div className=" flex gap-1 items-center">
                            <div>
                              <img src={require('../../assets/image/Form.png')} alt="" />
                            </div>
                            <p>{course?.lesson} Lesson</p>
                          </div>

                          <div className=" flex gap-1 items-center">
                            <div>
                              <img src={require('../../assets/image/Graduation Cap.png')} alt="" />
                            </div>

                            <p>{course?.duration}</p>
                            <p>{course?.periodType}</p>
                          </div>
                        </div>
                        <p className=" pt-2 text-sm">{course?.description}</p>
                        <div className=" flex items-center gap-2 pt-3">
                          <img src={require('../../assets/image/Form.png')} alt="" />

                          <p>121 Students</p>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </>
            ) : (
              <>
                <div className="text-center mt-8">
                  <p className="text-gray-600 text-lg">No courses available at the moment.</p>
                </div>
              </>
            )}
          </>
        )}
      </section>
    </Wrapper>
  );
};

export default Cources;
